import { isProd } from './isProd'

export const generateHederaScanUrl = (category, value) => {
  const baseUrl = isProd
    ? 'https://hashscan.io/mainnet'
    : 'https://hashscan.io/testnet'

  if (category === 'contract') return `${baseUrl}/contract/${value}`

  if (category === 'account') return `${baseUrl}/account/${value}`

  return `${baseUrl}/transaction/${value}`
}
